function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import IosArrowBack from "@meronex/icons/ios/IosArrowBack";
import moment from "moment";
// Request type options
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var requestTypes = [{
  value: "Confirmation required",
  label: "Confirmation required"
}, {
  value: "Requests",
  label: "Requests"
}, {
  value: "Queries",
  label: "Queries"
}, {
  value: "Documents required",
  label: "Documents required"
}, {
  value: "Updation of personal details",
  label: "Updation of personal details"
}, {
  value: "Construction update",
  label: "Construction update"
}, {
  value: "Any other concern",
  label: "Any other concern"
}];

// Subcategory options based on request type
var subCategoryOptions = {
  "Confirmation required": [{
    value: "Booking Confirmation",
    label: "Booking Confirmation"
  }, {
    value: "Confirmation on Allocation of Apartment",
    label: "Confirmation on Allocation of Apartment"
  }, {
    value: "Payment Confirmation Required",
    label: "Payment Confirmation Required"
  }],
  Requests: [{
    value: "Cancellation & Refund Request",
    label: "Cancellation & Refund Request"
  }, {
    value: "Refund In case of Non-Allotment of Apartment",
    label: "Refund In case of Non-Allotment of Apartment"
  }, {
    value: "Refund of Excess amount",
    label: "Refund of Excess amount"
  }, {
    value: "Refund of TDS amount",
    label: "Refund of TDS amount"
  }, {
    value: "TDS correction request",
    label: "TDS correction request"
  }, {
    value: "Endorsement request",
    label: "Endorsement request"
  }, {
    value: "Request for Interest Waiver",
    label: "Request for Interest Waiver"
  }, {
    value: "Name Addition Request",
    label: "Name Addition Request"
  }, {
    value: "Name Deletion Request",
    label: "Name Deletion Request"
  }],
  Queries: [{
    value: "Query on GST",
    label: "Query on GST"
  }, {
    value: "Query on Payment Plan",
    label: "Query on Payment Plan"
  }, {
    value: "Query related to registration amount",
    label: "Query related to registration amount"
  }, {
    value: "Query related to TDS",
    label: "Query related to TDS"
  }, {
    value: "Query on Payment remittence",
    label: "Query on Payment remittence"
  }, {
    value: "Query related to Allotment letter",
    label: "Query related to Allotment letter"
  }, {
    value: "Query related to Home Loan",
    label: "Query related to Home Loan"
  }, {
    value: "Query related to banking documents",
    label: "Query related to banking documents"
  }, {
    value: "Query related to Agreement for Sale",
    label: "Query related to Agreement for Sale"
  }, {
    value: "Query related to Car Parking",
    label: "Query related to Car Parking"
  }, {
    value: "Query related to Possession",
    label: "Query related to Possession"
  }, {
    value: "Query related to project amenities/specifications",
    label: "Query related to project amenities/specifications"
  }, {
    value: "Query related to Club membership",
    label: "Query related to Club membership"
  }],
  "Documents required": [{
    value: "Payment request letter required",
    label: "Payment request letter required"
  }, {
    value: "Copy of Allotment letter over email",
    label: "Copy of Allotment letter over email"
  }, {
    value: "Receipts required",
    label: "Receipts required"
  }, {
    value: "Payment breakup required",
    label: "Payment breakup required"
  }, {
    value: "Statement of Accounts required",
    label: "Statement of Accounts required"
  }],
  "Updation of personal details": [{
    value: "Updations of Client details such as Phone Number, communication address",
    label: "Updations of Client details such as Phone Number, communication address"
  }, {
    value: "Client details to be updated",
    label: "Client details to be updated"
  }],
  "Construction update": [{
    value: "Construction Update",
    label: "Construction Update"
  }],
  "Other concern": [{
    value: "Issue with Max Estates App",
    label: "Issue with Max Estates App"
  }, {
    value: "Legal case",
    label: "Legal case"
  }]
};
export var NewTicketForm = function NewTicketForm(_ref) {
  var _location$state, _formData$requestType6, _config$contactUs, _formData$requestType7, _formData$requestType8;
  var userRole = _ref.userRole,
    isAuthenticated = _ref.isAuthenticated,
    winnreAuth = _ref.winnreAuth,
    config = _ref.config;
  var SPECIAL_REQUEST_TYPES = {
    BASIC: "Basic",
    CALLBACK: "Request Callback",
    DOCUMENT: "Document Submission"
  };
  var location = useLocation();
  var history = useHistory();
  // const { userRole, isAuthenticated } = useSelector((state) => state.auth);
  var searchParams = new URLSearchParams(location.search);
  var isReopen = searchParams.get("reopen") === "true";
  var ticketData = (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.ticket;
  // const config = getConfig();
  // const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  var _useState = useState({
      requestType: null,
      subCategory: null,
      message: ""
    }),
    _useState2 = _slicedToArray(_useState, 2),
    formData = _useState2[0],
    setFormData = _useState2[1];
  var SPECIAL_CLIENT_ID = "d8b0f9ddbc11b3121dae65f540384ba90b272a5bbbbb80576e7f9ae016469e44";
  var isSpecialClient = (config === null || config === void 0 ? void 0 : config.clientId) === SPECIAL_CLIENT_ID;
  console.log("isSpecialClient", isSpecialClient, config);

  // Special client extra fields
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    preferredDateTime = _useState4[0],
    setPreferredDateTime = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    documentFile = _useState6[0],
    setDocumentFile = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    documentTypes = _useState8[0],
    setDocumentTypes = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    selectedDocumentType = _useState0[0],
    setSelectedDocumentType = _useState0[1];
  var _useState1 = useState(""),
    _useState10 = _slicedToArray(_useState1, 2),
    otherDocumentType = _useState10[0],
    setOtherDocumentType = _useState10[1];
  var _useState11 = useState(""),
    _useState12 = _slicedToArray(_useState11, 2),
    uploadedFileUrl = _useState12[0],
    setUploadedFileUrl = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    loading = _useState14[0],
    setLoading = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedRequestType = _useState16[0],
    setSelectedRequestType = _useState16[1];
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    project = _useState18[0],
    setProject = _useState18[1];
  var _useState19 = useState({}),
    _useState20 = _slicedToArray(_useState19, 2),
    errors = _useState20[0],
    setErrors = _useState20[1];
  var _useState21 = useState([]),
    _useState22 = _slicedToArray(_useState21, 2),
    projectList = _useState22[0],
    setProjectList = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    isReopenMode = _useState24[0],
    setIsReopenMode = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    isFormDisabled = _useState26[0],
    setIsFormDisabled = _useState26[1];
  console.log("ticketData from requestForm", ticketData);
  var _useState27 = useState(null),
    _useState28 = _slicedToArray(_useState27, 2),
    daysLeftToReopen = _useState28[0],
    setDaysLeftToReopen = _useState28[1];
  var _useState29 = useState(""),
    _useState30 = _slicedToArray(_useState29, 2),
    timeLeft = _useState30[0],
    setTimeLeft = _useState30[1];
  var selectMenuPortalTarget = typeof window !== "undefined" ? document.body : null;
  var commonSelectStyles = {
    container: function container(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        width: "100%"
      });
    },
    control: function control(styles, state) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        backgroundColor: "#FFFFFF",
        borderRadius: "6px",
        opacity: "0.95",
        paddingLeft: "2px",
        paddingRight: "2px",
        paddingTop: "5px",
        paddingBottom: "5px",
        border: state.isFocused ? "1px solid #6b7280" : "1px solid #d1d5db",
        boxShadow: "none",
        "&:hover": {
          border: "1px solid #E5E7EB"
        }
      });
    },
    placeholder: function placeholder(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        color: "#333c4d",
        fontFamily: "system-ui",
        fontWeight: "normal"
      });
    },
    menuPortal: function menuPortal(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        zIndex: 9999
      });
    },
    menu: function menu(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        zIndex: 9999
      });
    }
  };
  useEffect(function () {
    // if (isReopen && ticketData?.resolvedDate) {
    if (isReopen) {
      var calculateTimeLeft = function calculateTimeLeft() {
        var resolved = moment(ticketData.resolvedDate);
        // const resolved = moment('2025-09-24T00:13:30.105359');
        var now = moment();
        var deadline = moment(resolved).add(7, "days");
        if (now.isAfter(deadline)) {
          setDaysLeftToReopen(0);
          setTimeLeft("00:00:00");
          return;
        }
        var duration = moment.duration(deadline.diff(now));
        var days = Math.floor(duration.asDays());
        var hours = duration.hours().toString().padStart(2, "0");
        var minutes = duration.minutes().toString().padStart(2, "0");
        var seconds = duration.seconds().toString().padStart(2, "0");
        setDaysLeftToReopen(days);
        setTimeLeft("".concat(hours, ":").concat(minutes, ":").concat(seconds));
      };
      calculateTimeLeft();
      var interval = setInterval(calculateTimeLeft, 1000);
      return function () {
        return clearInterval(interval);
      };
    } else {
      setDaysLeftToReopen(null);
      setTimeLeft("");
    }
  }, [isReopen, ticketData]);

  // Prefill form when in reopen mode
  useEffect(function () {
    if (isReopen && ticketData) {
      setIsReopenMode(true);
      setIsFormDisabled(true);
      setProject({
        projectName: ticketData.projectName,
        id: ticketData.projectId
      });
      // Prefill form data
      setFormData(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          requestType: {
            value: ticketData.requestType,
            label: ticketData.requestType
          },
          subCategory: {
            value: ticketData.subCategory,
            label: ticketData.subCategory
          },
          message: ticketData.message || "" // You might want to keep this empty for new message
        });
      });
    }
  }, [isReopen, ticketData]);
  var projectSelected = function projectSelected(val) {
    setProject({
      projectName: val.label,
      id: val.value
    });
  };

  // Format request type options for react-select
  var requestTypeSelectOptions = (isSpecialClient ? [{
    value: SPECIAL_REQUEST_TYPES.BASIC,
    label: SPECIAL_REQUEST_TYPES.BASIC
  }, {
    value: SPECIAL_REQUEST_TYPES.CALLBACK,
    label: SPECIAL_REQUEST_TYPES.CALLBACK
  }, {
    value: SPECIAL_REQUEST_TYPES.DOCUMENT,
    label: SPECIAL_REQUEST_TYPES.DOCUMENT
  }] : requestTypes).map(function (type) {
    return {
      value: type.value,
      label: type.label
    };
  });

  // Format subcategory options based on selected request type
  var getSubCategoryOptions = function getSubCategoryOptions() {
    if (!selectedRequestType) return [];
    return (subCategoryOptions[selectedRequestType] || []).map(function (item) {
      return {
        value: item.value,
        label: item.label
      };
    });
  };
  var subCategorySelectOptions = getSubCategoryOptions();
  var handleInputChange = function handleInputChange(e) {
    var _e$target = e.target,
      name = _e$target.name,
      value = _e$target.value;
    setFormData(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, name, value));
    });

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, name, ""));
      });
    }
  };

  // Handlers for special client fields
  var handlePreferredDateTimeChange = function handlePreferredDateTimeChange(val) {
    return setPreferredDateTime(val);
  };
  var getLocalDateString = function getLocalDateString() {
    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, "0");
    var day = String(date.getDate()).padStart(2, "0");
    return "".concat(year, "-").concat(month, "-").concat(day);
  };
  var getAvailableTimeSlots = function getAvailableTimeSlots(selectedDateStr) {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var selectedDate = new Date(selectedDateStr);
    selectedDate.setHours(0, 0, 0, 0);
    var isToday = selectedDate.getTime() === today.getTime();
    var slots = [];
    var minAllowed = new Date(Date.now() + 60 * 60 * 1000);
    for (var totalMinutes = 10 * 60; totalMinutes <= 20 * 60; totalMinutes += 15) {
      var hour = Math.floor(totalMinutes / 60);
      var min = totalMinutes % 60;
      var timeStr = "".concat(String(hour).padStart(2, "0"), ":").concat(String(min).padStart(2, "0"));
      var slotTime = new Date(selectedDateStr + "T" + timeStr + ":00");

      // If today, only show times >= 1 hour from now
      if (isToday) {
        if (slotTime >= minAllowed) {
          slots.push(timeStr);
        }
      } else {
        // For future dates, show all times 10:00-20:00
        slots.push(timeStr);
      }
    }
    return slots;
  };
  useEffect(function () {
    var today = getLocalDateString();
    var firstAvailableSlot = getAvailableTimeSlots(today)[0];
    if (firstAvailableSlot) {
      setPreferredDateTime("".concat(today, "T").concat(firstAvailableSlot, ":00"));
    }
  }, []);
  var handleFileChange = function handleFileChange(e) {
    var file = e.target.files && e.target.files[0];
    if (file) setDocumentFile(file);
  };
  var handleDocumentTypeSelect = function handleDocumentTypeSelect(val) {
    var nextType = (val === null || val === void 0 ? void 0 : val.value) || null;
    setSelectedDocumentType(nextType);
    if (nextType !== "OTHER") {
      setOtherDocumentType("");
    }
  };
  var normalizeProjectList = function normalizeProjectList(rawList) {
    if (!Array.isArray(rawList)) return [];
    return rawList.map(function (item) {
      return {
        id: (item === null || item === void 0 ? void 0 : item.projectId) || (item === null || item === void 0 ? void 0 : item.id),
        projectName: item === null || item === void 0 ? void 0 : item.projectName
      };
    }).filter(function (item) {
      return item.id && item.projectName;
    });
  };
  var handleSelectChange = function handleSelectChange(selectedOption, _ref2) {
    var name = _ref2.name;
    setFormData(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, name, selectedOption));
    });
    if (name === "requestType") {
      setSelectedRequestType((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) || null);
      // Reset subcategory when request type changes
      setFormData(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          subCategory: null
        });
      });
    }

    // Clear error when user makes a selection
    if (errors[name]) {
      setErrors(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, name, ""));
      });
    }
  };
  var getProjects = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _customerPropertyRes$, customerPropertyRes, customerProjectList, _fallbackRes$data, fallbackRes, fallbackProjectList, _t, _t2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return winnreAuth({
              method: "GET",
              url: "/winnre/user/property/customer?pageNumber=0&pageSize=5"
            });
          case 1:
            customerPropertyRes = _context.v;
            customerProjectList = normalizeProjectList((customerPropertyRes === null || customerPropertyRes === void 0 ? void 0 : customerPropertyRes.content) || (customerPropertyRes === null || customerPropertyRes === void 0 || (_customerPropertyRes$ = customerPropertyRes.data) === null || _customerPropertyRes$ === void 0 ? void 0 : _customerPropertyRes$.content) || (customerPropertyRes === null || customerPropertyRes === void 0 ? void 0 : customerPropertyRes.data) || (customerPropertyRes === null || customerPropertyRes === void 0 ? void 0 : customerPropertyRes.contentList));
            if (!(customerProjectList.length > 0)) {
              _context.n = 2;
              break;
            }
            setProjectList(customerProjectList);
            return _context.a(2);
          case 2:
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            console.error("Customer property API failed, falling back", _t);
          case 4:
            _context.p = 4;
            _context.n = 5;
            return winnreAuth({
              method: "GET",
              url: "/winnre/user/project/all-names/v2?isLaunched=true"
            });
          case 5:
            fallbackRes = _context.v;
            fallbackProjectList = normalizeProjectList((fallbackRes === null || fallbackRes === void 0 ? void 0 : fallbackRes.content) || (fallbackRes === null || fallbackRes === void 0 || (_fallbackRes$data = fallbackRes.data) === null || _fallbackRes$data === void 0 ? void 0 : _fallbackRes$data.content) || (fallbackRes === null || fallbackRes === void 0 ? void 0 : fallbackRes.data));
            setProjectList(fallbackProjectList);
            _context.n = 7;
            break;
          case 6:
            _context.p = 6;
            _t2 = _context.v;
            console.error("Fallback project API failed", _t2);
            setProjectList([]);
          case 7:
            return _context.a(2);
        }
      }, _callee, null, [[4, 6], [0, 3]]);
    }));
    return function getProjects() {
      return _ref3.apply(this, arguments);
    };
  }();
  var formIsValid = false;
  if (!isSpecialClient) {
    if (project && formData.requestType && formData.subCategory && formData.message) {
      formIsValid = true;
    }
  } else {
    var _formData$requestType;
    // Special client validation
    var type = (_formData$requestType = formData.requestType) === null || _formData$requestType === void 0 ? void 0 : _formData$requestType.value;
    if (type === SPECIAL_REQUEST_TYPES.BASIC) {
      formIsValid = project && formData.message && formData.message.trim().length > 0;
    } else if (type === SPECIAL_REQUEST_TYPES.CALLBACK) {
      formIsValid = project && preferredDateTime && new Date(preferredDateTime).getTime() > Date.now();
    } else if (type === SPECIAL_REQUEST_TYPES.DOCUMENT) {
      // document type and file required
      formIsValid = project && selectedDocumentType && (selectedDocumentType !== "OTHER" || otherDocumentType.trim()) && (documentFile || uploadedFileUrl);
    }
  }
  var handleSubmit = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _formData$requestType2, _type, _formData$requestType3, basePayload, _formData$subCategory, _formData$requestType4, _formData$requestType5, _type2, formattedCallbackTime, documentType, endpoint, _uploadData$data, _uploadData$data2, fd, uploadData, fileUrl, response, msg, successMessage, _error$response, errorMessage, _t3, _t4;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            if (formIsValid) {
              _context2.n = 1;
              break;
            }
            _type = (_formData$requestType2 = formData.requestType) === null || _formData$requestType2 === void 0 ? void 0 : _formData$requestType2.value;
            if (isSpecialClient && _type === SPECIAL_REQUEST_TYPES.CALLBACK) {
              toast.error("Please provide a future preferred date/time between 10:00-20:00");
            } else if (isSpecialClient && _type === SPECIAL_REQUEST_TYPES.DOCUMENT) {
              toast.error("Please select a document type and upload a file");
            } else {
              toast.error("Please fill all required fields");
            }
            return _context2.a(2);
          case 1:
            setLoading(true);
            _context2.p = 2;
            basePayload = {
              requestType: (_formData$requestType3 = formData.requestType) === null || _formData$requestType3 === void 0 ? void 0 : _formData$requestType3.value,
              message: formData.message,
              source: userRole === "CUSTOMER" ? "CUSTOMER" : "CHANNEL_PARTNER",
              smartTicketStatus: isReopenMode ? "REOPEN" : "OPEN",
              projectId: project === null || project === void 0 ? void 0 : project.id,
              projectName: project === null || project === void 0 ? void 0 : project.projectName
            };
            if (isSpecialClient) {
              _context2.n = 3;
              break;
            }
            basePayload = _objectSpread(_objectSpread({}, basePayload), {}, {
              projectId: project === null || project === void 0 ? void 0 : project.id,
              projectName: project === null || project === void 0 ? void 0 : project.projectName,
              subCategory: (_formData$subCategory = formData.subCategory) === null || _formData$subCategory === void 0 ? void 0 : _formData$subCategory.value
            });
            _context2.n = 5;
            break;
          case 3:
            basePayload.subCategory = (_formData$requestType4 = formData.requestType) === null || _formData$requestType4 === void 0 ? void 0 : _formData$requestType4.value;
            _type2 = (_formData$requestType5 = formData.requestType) === null || _formData$requestType5 === void 0 ? void 0 : _formData$requestType5.value;
            if (_type2 === SPECIAL_REQUEST_TYPES.CALLBACK) {
              formattedCallbackTime = moment(preferredDateTime).format("DD MMM YYYY, hh:mm A");
              basePayload.message = "requesting callback at ".concat(formattedCallbackTime);
              basePayload.callBackTime = preferredDateTime;
            }
            if (!(_type2 === SPECIAL_REQUEST_TYPES.DOCUMENT)) {
              _context2.n = 5;
              break;
            }
            if (!(selectedDocumentType === "OTHER" && !otherDocumentType.trim())) {
              _context2.n = 4;
              break;
            }
            toast.error("Please enter document type");
            setLoading(false);
            return _context2.a(2);
          case 4:
            documentType = selectedDocumentType === "OTHER" ? otherDocumentType.trim() : selectedDocumentType;
            basePayload.documentType = documentType;
            basePayload.message = "Uploaded ".concat(documentType, " document");
          case 5:
            endpoint = isReopenMode ? "/winnre/user/smartTicket/update/".concat(ticketData.id) : "/winnre/user/smartTicket"; // Upload the document before saving the smart ticket.
            if (!(isSpecialClient && documentFile)) {
              _context2.n = 10;
              break;
            }
            _context2.p = 6;
            fd = new FormData();
            fd.append("file", documentFile);
            _context2.n = 7;
            return winnreAuth({
              method: "POST",
              url: "/winnre/user/smartTicket/uploadDocument",
              data: fd,
              isFormData: true
            });
          case 7:
            uploadData = _context2.v;
            fileUrl = (uploadData === null || uploadData === void 0 || (_uploadData$data = uploadData.data) === null || _uploadData$data === void 0 ? void 0 : _uploadData$data.url) || (uploadData === null || uploadData === void 0 || (_uploadData$data2 = uploadData.data) === null || _uploadData$data2 === void 0 ? void 0 : _uploadData$data2.docUrl) || (uploadData === null || uploadData === void 0 ? void 0 : uploadData.url) || (uploadData === null || uploadData === void 0 ? void 0 : uploadData.docUrl) || (uploadData === null || uploadData === void 0 ? void 0 : uploadData.message);
            if (fileUrl) {
              _context2.n = 8;
              break;
            }
            toast.error("File upload did not return a file URL");
            setLoading(false);
            return _context2.a(2);
          case 8:
            setUploadedFileUrl(fileUrl);
            basePayload = _objectSpread(_objectSpread({}, basePayload), {}, {
              docUrl: fileUrl
            });
            _context2.n = 10;
            break;
          case 9:
            _context2.p = 9;
            _t3 = _context2.v;
            console.error("File upload failed:", _t3);
            toast.error("File upload failed");
            setLoading(false);
            return _context2.a(2);
          case 10:
            _context2.n = 11;
            return winnreAuth({
              method: "POST",
              url: endpoint,
              data: basePayload
            });
          case 11:
            response = _context2.v;
            console.log("Response from submit:", response);
            if (!(response && (response.status === "FAILED" || response.status && response.status !== "SUCCESS" && response.status !== "OK"))) {
              _context2.n = 12;
              break;
            }
            msg = response.message || "Submission failed";
            throw new Error(msg);
          case 12:
            // Reset form
            setFormData({
              projectId: "",
              requestType: "",
              subCategory: "",
              message: ""
            });
            setSelectedRequestType("");
            // reset special fields
            setPreferredDateTime("");
            setDocumentFile(null);
            setSelectedDocumentType(null);
            setOtherDocumentType("");
            setUploadedFileUrl("");

            // Show success message
            successMessage = isReopenMode ? "Ticket reopened successfully" : "Request submitted successfully";
            toast.success(successMessage);

            // Redirect after a short delay
            setTimeout(function () {
              history.push("/myprofile/support-tickets/list");
            }, 1000);
            _context2.n = 14;
            break;
          case 13:
            _context2.p = 13;
            _t4 = _context2.v;
            console.error("Error submitting form:", _t4);
            errorMessage = ((_error$response = _t4.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 ? void 0 : _error$response.message) || "An error occurred while processing your request";
            toast.error(errorMessage);
          case 14:
            _context2.p = 14;
            setLoading(false);
            return _context2.f(14);
          case 15:
            return _context2.a(2);
        }
      }, _callee2, null, [[6, 9], [2, 13, 14, 15]]);
    }));
    return function handleSubmit() {
      return _ref4.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (!isReopen) {
      getProjects();
    }
  }, []);
  useEffect(function () {
    if (!project && Array.isArray(projectList) && projectList.length === 1) {
      var onlyProject = projectList[0];
      setProject({
        projectName: onlyProject.projectName,
        id: onlyProject.id
      });
    }
  }, [projectList, project]);

  // Fetch document types for special client from Documents section
  useEffect(function () {
    if (!isSpecialClient) return;
    setDocumentTypes([{
      value: "AADHAAR",
      label: "AADHAAR"
    }, {
      value: "ACCOUNT_STATEMENT",
      label: "ACCOUNT_STATEMENT"
    }, {
      value: "ADDRESS",
      label: "ADDRESS"
    }, {
      value: "AGREEMENT_FOR_SALE",
      label: "AGREEMENT_FOR_SALE"
    }, {
      value: "APPROVED_PROJECT_FINANCIAL",
      label: "APPROVED_PROJECT_FINANCIAL"
    }, {
      value: "APPROVED_SITE_PLAN",
      label: "APPROVED_SITE_PLAN"
    }, {
      value: "AUTHORIZATION_LETTER",
      label: "AUTHORIZATION_LETTER"
    }, {
      value: "BOARD_RESOLUTION",
      label: "BOARD_RESOLUTION"
    }, {
      value: "BIRTH_CERTIFICATE",
      label: "BIRTH_CERTIFICATE"
    }, {
      value: "BOOKING_APPLICATION",
      label: "BOOKING_APPLICATION"
    }, {
      value: "BUSINESS_CARD",
      label: "BUSINESS_CARD"
    }, {
      value: "CA_MSME_CERTIFICATE",
      label: "CA_MSME_CERTIFICATE"
    }, {
      value: "CANCELLED CHEQUE",
      label: "CANCELLED CHEQUE"
    }, {
      value: "COMMENCEMENT_CERTIFICATE",
      label: "COMMENCEMENT_CERTIFICATE"
    }, {
      value: "CODE_OF_CONDUCT",
      label: "CODE_OF_CONDUCT"
    }, {
      value: "COVER_LETTER",
      label: "COVER_LETTER"
    }, {
      value: "DEMAND",
      label: "DEMAND"
    }, {
      value: "E_INVOICE_DECLARATION",
      label: "E_INVOICE_DECLARATION"
    }, {
      value: "GST",
      label: "GST"
    }, {
      value: "GST_DECLARATION",
      label: "GST_DECLARATION"
    }, {
      value: "INCORPORATION",
      label: "INCORPORATION"
    }, {
      value: "INCOME_TAX_RETURN",
      label: "INCOME_TAX_RETURN"
    }, {
      value: "MARRIAGE_CERTIFICATE",
      label: "MARRIAGE_CERTIFICATE"
    }, {
      value: "MASKED_AADHAAR",
      label: "MASKED_AADHAAR"
    }, {
      value: "MSME",
      label: "MSME"
    }, {
      value: "NO_OBJECTION_CERTIFICATE",
      label: "NO_OBJECTION_CERTIFICATE"
    }, {
      value: "NOTICE",
      label: "NOTICE"
    }, {
      value: "OTHER",
      label: "OTHER"
    }, {
      value: "PAN",
      label: "PAN"
    }, {
      value: "PARKING_ALLOTTMENT_LETTER",
      label: "PARKING_ALLOTTMENT_LETTER"
    }, {
      value: "PARTNERSHIP_DEED",
      label: "PARTNERSHIP_DEED"
    }, {
      value: "PASSPORT",
      label: "PASSPORT"
    }, {
      value: "PAYMENT_PLAN",
      label: "PAYMENT_PLAN"
    }, {
      value: "POSSESSION_LETTER",
      label: "POSSESSION_LETTER"
    }, {
      value: "PROJECT_APPROVAL_CERTIFICATE",
      label: "PROJECT_APPROVAL_CERTIFICATE"
    }, {
      value: "RECEIPT",
      label: "RECEIPT"
    }, {
      value: "RECTIFICATION_DEED",
      label: "RECTIFICATION_DEED"
    }, {
      value: "REMINDER_LETTER",
      label: "REMINDER_LETTER"
    }, {
      value: "RERA",
      label: "RERA"
    }, {
      value: "SIGNED_AGREEMENT",
      label: "SIGNED_AGREEMENT"
    }, {
      value: "SUBVENTION_AGREEMENT",
      label: "SUBVENTION_AGREEMENT"
    }, {
      value: "TDS",
      label: "TDS"
    }, {
      value: "WELCOME_LETTER",
      label: "WELCOME_LETTER"
    }]);
  }, [isSpecialClient]);

  // console.log('selected project', project);
  // console.log('selected request type', formData.requestType);
  // console.log('selected subcategory', formData.subCategory);
  // console.log('selected message', formData.message);

  return /*#__PURE__*/_jsx("div", {
    children: isAuthenticated && /*#__PURE__*/_jsxs("div", {
      className: " w-full md:w-[80%] md:pl-3 lg:pl-7 2xl:pl-7 ",
      children: [/*#__PURE__*/_jsxs("button", {
        onClick: function onClick() {
          return history.push("/myprofile/support-tickets/list");
        },
        className: "flex items-center text-primary cursor-pointer mb-4 mt-1",
        children: [/*#__PURE__*/_jsx(IosArrowBack, {
          className: "mr-1"
        }), /*#__PURE__*/_jsx("span", {
          className: "",
          children: "Back to Tickets"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "text-center pb-8 space-y-2",
        children: [/*#__PURE__*/_jsx("h1", {
          className: "text-3xl leading-[1.1] font-bold ".concat(config === null || config === void 0 ? void 0 : config.headingFont),
          children: isReopen ? "Reopen Support Ticket" : "Raise a New Request"
        }), /*#__PURE__*/_jsx("p", {
          className: "w-[85%] md:w-[70%] lg:w-[88%] mx-auto leading-[1.5] md:text-lg ".concat(config === null || config === void 0 ? void 0 : config.bodyFont),
          children: isReopen ? "Please update the message below to provide more details about your concern. Our team will review and get back to you shortly." : "Please fill out the form below to submit your request. Our team will get back to you shortly."
        }), isReopen && daysLeftToReopen !== null && /*#__PURE__*/_jsx("div", {
          className: "mt-6 p-3 bg-gray-50 border border-gray-200 rounded-lg max-w-2xl mx-auto",
          children: /*#__PURE__*/_jsx("div", {
            className: "flex flex-col items-center text-center",
            children: daysLeftToReopen > 0 ? /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsxs("span", {
                className: "font-semibold",
                children: [daysLeftToReopen, " ", daysLeftToReopen === 1 ? "day" : "days", " ", timeLeft]
              }), " ", /*#__PURE__*/_jsx("span", {
                className: "font-semibold text-base",
                children: "Left to reopen this ticket"
              })]
            }) : /*#__PURE__*/_jsx("span", {
              className: "font-semibold text-base",
              children: "The reopening period for this ticket has ended"
            })
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "space-y-6",
        children: [/*#__PURE__*/_jsx("div", {
          className: "mt-2 mb-2 md:mb-2",
          children: /*#__PURE__*/_jsx(Select, {
            placeholder: "Your Project*",
            options: projectList === null || projectList === void 0 ? void 0 : projectList.map(function (p) {
              return {
                label: p.projectName,
                value: p.id
              };
            }),
            menuPortalTarget: selectMenuPortalTarget,
            menuPosition: "fixed",
            menuPlacement: "auto",
            maxMenuHeight: 220,
            onChange: function onChange(val) {
              projectSelected(val);
            },
            value: project ? {
              value: project.id,
              label: project.projectName
            } : null,
            isDisabled: isFormDisabled,
            styles: commonSelectStyles
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "mt-2 mb-2 md:mb-2",
          children: /*#__PURE__*/_jsx(Select, {
            name: "requestType",
            value: formData.requestType,
            onChange: handleSelectChange,
            options: requestTypeSelectOptions,
            isDisabled: isFormDisabled,
            placeholder: "Select request type...",
            isSearchable: true,
            menuPortalTarget: selectMenuPortalTarget,
            menuPosition: "fixed",
            menuPlacement: "auto",
            maxMenuHeight: 220,
            styles: commonSelectStyles
          })
        }), !isSpecialClient && /*#__PURE__*/_jsx("div", {
          className: "mt-2 mb-2 md:mb-2",
          children: /*#__PURE__*/_jsx(Select, {
            name: "subCategory",
            value: formData.subCategory,
            onChange: handleSelectChange,
            options: subCategorySelectOptions,
            placeholder: !selectedRequestType ? "Select a request type first" : "Select subcategory...",
            isDisabled: !selectedRequestType || isFormDisabled,
            isSearchable: true,
            menuPortalTarget: selectMenuPortalTarget,
            menuPosition: "fixed",
            menuPlacement: "auto",
            maxMenuHeight: 220,
            styles: commonSelectStyles
          })
        }), !(isSpecialClient && ((_formData$requestType6 = formData.requestType) === null || _formData$requestType6 === void 0 ? void 0 : _formData$requestType6.value) !== SPECIAL_REQUEST_TYPES.BASIC) && /*#__PURE__*/_jsxs("div", {
          className: "mt-2 mb-2 md:mb-2",
          children: [/*#__PURE__*/_jsxs("label", {
            className: " ".concat((_config$contactUs = config.contactUs) === null || _config$contactUs === void 0 ? void 0 : _config$contactUs.font, " block uppercase tracking-wide text-xs font-bold mb-2 text-black"),
            "for": "grid-password",
            children: ["Message ", /*#__PURE__*/_jsx("span", {
              className: "text-red-500",
              children: "*"
            })]
          }), /*#__PURE__*/_jsx("textarea", {
            className: "text-gray-700 no-resize block w-full  border  rounded py-3 px-4 mb-3 leading-tight focus:outline-none  h-48 resize-none",
            name: "message",
            value: formData.message,
            onChange: handleInputChange
          })]
        }), isSpecialClient && ((_formData$requestType7 = formData.requestType) === null || _formData$requestType7 === void 0 ? void 0 : _formData$requestType7.value) === SPECIAL_REQUEST_TYPES.CALLBACK && /*#__PURE__*/_jsx("div", {
          className: "space-y-3",
          children: /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsxs("label", {
              className: "block text-xs font-bold mb-1",
              children: ["Preferred Date & Time", " ", /*#__PURE__*/_jsx("span", {
                className: "text-red-500",
                children: "*"
              })]
            }), /*#__PURE__*/_jsx("input", {
              type: "date",
              className: "w-full border rounded px-3 py-2 mb-2",
              min: function () {
                return getLocalDateString();
              }(),
              defaultValue: function () {
                return getLocalDateString();
              }(),
              onChange: function onChange(e) {
                var date = e.target.value; // yyyy-mm-dd
                // Get first available time slot for the new date
                var slots = getAvailableTimeSlots(date);
                var firstSlot = slots.length > 0 ? slots[0] : "";
                if (!firstSlot) {
                  toast.error("No callback slots available for selected date. Please choose another date.");
                  setPreferredDateTime("");
                  return;
                }
                // Update the time select value
                var timeSelect = document.querySelector("select");
                if (timeSelect) {
                  timeSelect.value = firstSlot;
                }
                setPreferredDateTime(date + "T" + firstSlot + ":00");
              }
            }), /*#__PURE__*/_jsx("select", {
              className: "w-full border rounded px-3 py-2",
              defaultValue: function () {
                var dateInputs = document.querySelector('input[type="date"]');
                var selectedDate = (dateInputs === null || dateInputs === void 0 ? void 0 : dateInputs.value) || getLocalDateString();
                var slots = getAvailableTimeSlots(selectedDate);
                return slots.length > 0 ? slots[0] : "";
              }(),
              onChange: function onChange(e) {
                var time = e.target.value; // HH:MM
                var dateInputs = document.querySelector('input[type="date"]');
                var date = dateInputs ? dateInputs.value : getLocalDateString();
                var dt = new Date(date + "T" + time + ":00");
                var minAllowed = new Date(Date.now() + 60 * 60 * 1000);
                var today = new Date();
                today.setHours(0, 0, 0, 0);
                var selectedDate = new Date(date);
                selectedDate.setHours(0, 0, 0, 0);

                // enforce between 10:00 and 20:00
                var totalMinutes = dt.getHours() * 60 + dt.getMinutes();
                if (totalMinutes < 10 * 60 || totalMinutes > 20 * 60) {
                  toast.error("Please select time between 10:00 and 20:00");
                  return;
                }

                // If today, check if time is at least 1 hour from now
                if (selectedDate.getTime() === today.getTime()) {
                  if (dt < minAllowed) {
                    toast.error("Please select preferred time at least 1 hour from now");
                    return;
                  }
                }
                setPreferredDateTime(dt.toISOString());
              },
              children: function () {
                var dateInputs = document.querySelector('input[type="date"]');
                var selectedDate = (dateInputs === null || dateInputs === void 0 ? void 0 : dateInputs.value) || getLocalDateString();
                var slots = getAvailableTimeSlots(selectedDate);
                if (!slots.length) {
                  return /*#__PURE__*/_jsx("option", {
                    value: "",
                    children: "No available slots"
                  });
                }
                return slots.map(function (timeStr) {
                  return /*#__PURE__*/_jsx("option", {
                    value: timeStr,
                    children: timeStr
                  }, timeStr);
                });
              }()
            })]
          })
        }), isSpecialClient && ((_formData$requestType8 = formData.requestType) === null || _formData$requestType8 === void 0 ? void 0 : _formData$requestType8.value) === SPECIAL_REQUEST_TYPES.DOCUMENT && /*#__PURE__*/_jsxs("div", {
          className: "space-y-3",
          children: [/*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("label", {
              className: "block text-xs font-bold mb-1",
              children: "Document Type"
            }), /*#__PURE__*/_jsx(Select, {
              options: documentTypes,
              onChange: handleDocumentTypeSelect,
              isClearable: true,
              menuPortalTarget: selectMenuPortalTarget,
              menuPosition: "fixed",
              menuPlacement: "auto",
              maxMenuHeight: 220,
              styles: commonSelectStyles
            })]
          }), selectedDocumentType === "OTHER" && /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsxs("label", {
              className: "block text-xs font-bold mb-1",
              children: ["Document Name ", /*#__PURE__*/_jsx("span", {
                className: "text-red-500",
                children: "*"
              })]
            }), /*#__PURE__*/_jsx("input", {
              type: "text",
              value: otherDocumentType,
              onChange: function onChange(e) {
                return setOtherDocumentType(e.target.value);
              },
              className: "w-full border rounded px-3 py-2",
              placeholder: "Enter document type"
            })]
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsxs("label", {
              className: "block text-xs font-bold mb-1",
              children: ["Upload Document ", /*#__PURE__*/_jsx("span", {
                className: "text-red-500",
                children: "*"
              })]
            }), /*#__PURE__*/_jsx("input", {
              type: "file",
              accept: "*/*",
              onChange: handleFileChange,
              disabled: loading
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "text-xs text-gray-600",
            children: ["Will submit as:", " ", /*#__PURE__*/_jsx("span", {
              className: "font-semibold",
              children: selectedDocumentType || "—"
            })]
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "pt-2",
          children: /*#__PURE__*/_jsx("button", {
            type: "button",
            onClick: handleSubmit,
            disabled: !formIsValid || loading,
            className: "w-full py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white transition-colors duration-200 ".concat(!formIsValid || loading ? "bg-primary opacity-50 cursor-not-allowed" : "bg-primary focus:outline-none"),
            children: loading ? "Submitting..." : isReopen ? "Reopen Ticket" : "Submit Ticket"
          })
        })]
      })]
    })
  });
};